import React from "react";
import fractions from "../../assests/images/fractions.svg";
import fractionsMobile from "../../assests/images/fractionsMobile.svg";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";
import { Link } from "react-router-dom";
import Table from "../pages/Fractions/Table";

export default function FractionsText(props) {
  const { isMobile, isTablet, isDesktop, isDesktopLogin, isTabletLogin } =
    useResponsiveFlags();
  const desktopScreen = props.loggedin ? isDesktopLogin : isDesktop;
  const tabletScreen = props.loggedin ? isTabletLogin : isTablet;
  return (
    <>
      {/* Top Heading Part */}
      <section
        style={{
          background: "#E6F4FA",
        }}
      >
        <div
          style={{
            padding: desktopScreen
              ? "51px 40px 95px 40px"
              : "40px 17px 72px 17px",
          }}
        >
          <p>Home &gt; iSort&trade; Fractions</p>
          <div
            className={desktopScreen ? "d-flex justify-content-between" : ""}
          >
            <p
              className="heading"
              style={{
                width: desktopScreen ? "48%" : "100%",
                lineHeight: "42px",
              }}
            >
              iSort&trade; Fractions
            </p>

            <p
              className="hometext2 para"
              style={{
                width: desktopScreen ? "37%" : "100%",
                marginTop: desktopScreen ? "0" : "2.25rem",
              }}
            >
              <p>
                iSort&trade; Fractions generates
                <strong> accurate cell type compositions in minutes</strong> from
                bulk expression profiles.
              </p>
              <p>
                Compatible for any tissue types, including FFPE, fresh frozen,
                and blood samples.
              </p>
            </p>
          </div>
        </div>
      </section>

      <div
        style={{
          padding: desktopScreen
            ? "96px 35px 62px 35px"
            : "62px 20px 62px 20px",
        }}
      >
        {/* Image SVG Part */}
        <div
          className={`${
            desktopScreen ? "" : "d-none"
          } d-flex justify-content-center`}
        >
          <img src={fractions} alt="iSort Fractions Process" width="70%" />
        </div>
        {/* Image SVG Part (for mobile)*/}

        <div
          className={`${
            desktopScreen ? "d-none" : ""
          } d-flex justify-content-center`}
        >
          <img src={fractionsMobile} alt="iSort Fractions Process" />
        </div>

        {/* features */}
        <div style={{ marginTop: desktopScreen ? "126px" : "90px" }}>
          <p className="home-card-title">Features</p>
          <div
            className="features-home"
            style={{ margin: !isMobile ? "34px 20px 0 20px " : "" }}
          >
            <div className="d-flex flex-column flex-md-row mb-4">
              <div className="col-md-6 d-flex flex-column justify-content-between pe-md-4 ">
                <p>
                  All you need is{" "}
                  <strong>bulk expression profiles in TPM</strong>. You can
                  generate
                  <strong> accurately quantified cell compositions</strong> in
                  minutes.
                </p>
                <hr />
              </div>
              <div className="col-md-6 d-flex flex-column justify-content-between ps-md-4 ">
                <p>
                  You can use
                  <strong> predefined and validated signature matrices</strong>.
                  iSort&trade; Fractions quantifies 22 immune cell types with
                  blood mode and additional 3 cell types with tissue mode as
                  shown below.
                </p>
                <hr />
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row mb-4">
              <div className="col-md-6 d-flex flex-column justify-content-between pe-md-4">
                <p>
                  Unlike single-cell assays, iSort&trade; Fractions does not
                  require cell dissociation. Your results are{" "}
                  <a
                    href="https://www.cibermed.com/products#fractions_comparison"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <strong>
                      free from artifacts introduced by dissociation
                    </strong>
                  </a>
                  .
                </p>
                <hr />{" "}
              </div>
              <div className="col-md-6 d-flex flex-column justify-content-between ps-md-4">
                <p>
                  You can run iSort&trade; Fractions either in a
                  <strong> browser</strong> (drag and drop your input file) or
                  <strong> locally</strong> by a Docker-containerized command
                  line tool. (User registration required to access the tools.)
                </p>
                <hr />
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row mb-4">
              <div className="col-md-6 d-flex flex-column justify-content-between pe-md-4">
                <p>
                  iSort&trade; Fractions is an <strong>optimized</strong>{" "}
                  version of{" "}
                  <a
                    href="https://pubmed.ncbi.nlm.nih.gov/25822800/"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "black" }}
                  >
                    CIBERSORT
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://pubmed.ncbi.nlm.nih.gov/31061481/"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "black" }}
                  >
                    CIBERSORTx
                  </a>
                  , which was originally developed by Stanford university, and
                  is the{" "}
                  <strong>
                    most widely used deconvolution tool in the field.
                  </strong>
                </p>
                <hr />{" "}
              </div>
              <div className="col-md-6 d-flex flex-column justify-content-between ps-md-4">
                {" "}
                <p>
                  <a
                    href="https://www.cibermed.com/products#SureSelect_technology"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <strong>
                      CiberMed is officially partnered with Agilent Technologies
                    </strong>
                  </a>
                  . Boost your accuracy further with SureSelect CD CiberMed
                  targeted sequencing panels.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>

        {/* Run iSort Section */}
        {props.loggedin ? (
          <>
            {/* text section */}
            <div style={{ margin: "26px 0 50px" }}>
              <p className="home-card-title">Run iSort&trade; Fractions</p>
              <div
                className="features-home"
                style={{ margin: !isMobile ? "34px 20px 0 20px " : "" }}
              >
                <p>
                  <b>Run iSort&trade; Fractions on a Browser</b>
                  <br />A user will upload the input file(s), run iSort&trade;
                  on browser, and download the results files.
                </p>
                <div style={{ margin: "30px 0 50px" }}>
                  <Link
                    to="/runisort"
                    className="continue-btn"
                    style={{
                      padding: "10px 25px",
                      textDecoration: "none",
                      fontSize: "18px",
                    }}
                  >
                    Run On Browser &nbsp; &rarr;
                  </Link>
                </div>
                <p>
                  <b>Run iSort&trade; Fractions Locally</b>
                  <br />A user will download the desktop application
                  containerized by Docker, and runs it locally. No need to
                  upload your input file(s). The desktop version is a
                  command-line tool without GUI (graphical user interface).
                </p>
                <div style={{ margin: "30px 0 50px " }}>
                  <Link
                    to="/runlocally"
                    className="continue-btn"
                    style={{
                      padding: "10px 63px 10px 25px",
                      textDecoration: "none",
                      fontSize: "18px",
                    }}
                  >
                    Run Locally &nbsp; &rarr;
                  </Link>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/*Just button */}
            <div style={{ margin: "50px 0" }}>
              <Link
                to="/#getStartedWithFractions"
                className="continue-btn"
                style={{
                  padding: "10px 25px",
                  textDecoration: "none",
                  fontSize: isMobile? "18px" : "24px",
                }}
              >
                Start using iSort&trade; Fractions &nbsp; &rarr;
              </Link>
            </div>
          </>
        )}
<Table loggedIn={props.loggedIn}/>
      </div>
    </>
  );
}
